import React from "react";
const mnpNumberContext = React.createContext({
    mnpNumber: '',
    updateMnpNumber: (number) => { }
});
export default mnpNumberContext;
